module.exports = __webpack_public_path__ + "static/media/whichThinnerThinnersList.1317d5d7.mp3";